export const apiEndpoints = {
  // Pickems
  pickems: '/pickems',
  getPickems: '/pickems',
  createPickem: '/pickems',
  getPickemById: (pickemId: string) => `/pickems/${pickemId}`,
  updatePickem: (pickemId: string) => `/pickems/${pickemId}`,
  deletePickem: (pickemId: string) => `/pickems/${pickemId}`,
  completePickem: (pickemId: string) => `/pickems/${pickemId}/complete`,
  forcePickemScoring: (pickemId: string) => `/pickems/${pickemId}/force-leaderboard-scoring`,
  startScoringAsync: (pickemId: string) => `/pickems/${pickemId}/start-scoring`,
  scoringStream: (pickemId: string) => `/pickems/${pickemId}/scoring-stream`,
  scoringStatus: '/pickems/scoring/status',
  recalculatePickemRanks: (pickemId: string) => `/pickems/${pickemId}/recalculate-ranks`,
  getPickemEntries: (pickemId: string) => `/pickems/${pickemId}/entries`,
  getPickemUserSelections: (pickemId: string, userId: string) =>
    `/pickems/${pickemId}/users/${userId}/selections`,

  // Questions
  questions: '/questions',
  getQuestions: '/questions',
  createQuestion: '/questions',
  updateQuestion: (pickemId: string) => `/pickems/${pickemId}/questions`,
  reorderQuestions: (pickemId: string) => `/pickems/${pickemId}/questions/reorder`,

  // Leagues
  leagues: '/leagues',
  getLeagues: '/leagues',
  createLeague: '/leagues',
  updateLeague: (leagueId: string) => `/leagues/${leagueId}`,
  deleteLeague: (leagueId: string) => `/leagues/${leagueId}`,

  // Leaderboard
  getPickemLeaderboard: (pickemId: string) => `/leaderboard/pickems/${pickemId}`,

  // Settings
  getSports: '/settings/sports',
  updateStatus: (settingsKey: string, id: string) => `/settings/${settingsKey}/${id}/status`,

  // Translation
  translate: '/translate',

  // Dev Data
  deleteAllPickems: '/dev-data/pickems',
  generatePickems: '/dev-data/generate-pickems',
  flushCache: '/dev-data/flush-cache',
  regenerateAggregateLeaderboards: '/aggregate-leaderboard/regenerate',
} as const;
